import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRainmeterComponent } from './simple-icons-rainmeter.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRainmeterComponent ],
    exports:      [ SimpleIconsRainmeterComponent ],
    bootstrap:    []
})
export class SimpleIconsRainmeterModule {}
